import { useAdvancingActivityCount } from "advancing/activity/useAdvancingActivityCount";
import { useAdvancingMessageToasts } from "advancing/messages/useAdvancingMessageToasts";
import { ActivityTab } from "advancingprovide/tabs/ActivityTab";
import { CheckAndProvideTab } from "advancingprovide/tabs/CheckAndProvideTab";
import { FilesTab } from "advancingprovide/tabs/FilesTab";
import { ParticipantsTab } from "advancingprovide/tabs/ParticipantsTab";
import { getProvideActivitySource, getProvideSidePanelQuery } from "advancingprovide/utils";
import { AdvancingSessionHeader } from "components/PurpleHeader/AdvancingSessionHeader";
import { ShortcutBar } from "components/ShortcutBar/ShortcutBar";
import { useTabRoute } from "pages/utils";
import React from "react";
import { useLoaderData, useParams } from "react-router";
import { useCustomQuery } from "utilities/hookutils";

const tabs = [
  { key: "checkAndProvide", label: "Check & provide", Component: CheckAndProvideTab },
  { key: "participants", label: RESX.Advancing.Participants, Component: ParticipantsTab },
  { key: "files", label: RESX.File.Files, Component: FilesTab },
  { key: "activity", label: "Activity log", Component: ActivityTab }
] as const;

export const AdvancingProvideApp = () => {
  const { secret } = useParams();
  const { advancingSession } = useLoaderData<server.viewmodel.AdvancingProvideFrontModel>();
  const activityCount = useAdvancingActivityCount(getProvideActivitySource(secret), advancingSession.advancingSessionId);
  const sidePanelQuery = useCustomQuery(getProvideSidePanelQuery(secret));
  const { activeTab, onTabChange, getTabHref } = useTabRoute(tabs);
  useAdvancingMessageToasts(advancingSession.advancingSessionId, "fromAgent");

  const counts: Partial<Record<typeof tabs[number]["key"], number>> = {
    participants: sidePanelQuery.data?.data.participants.length,
    files: sidePanelQuery.data?.data.advancingSession.filesCount,
    activity: activityCount
  };

  return <div className="flex-column gap-large">
    <AdvancingSessionHeader advancingSession={sidePanelQuery.data?.data.advancingSession ?? advancingSession} />
    <ShortcutBar
      options={tabs.map(tab => ({ label: tab.label, value: tab.key, href: getTabHref(tab.key), count: counts[tab.key] }))}
      value={activeTab.key}
      onChange={onTabChange}
    />
    <activeTab.Component />
  </div>;
};
